export const arraysShallowEqual = (a, b) => {
    return (Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((v, index) => v === b[index]));
};
const withSortedKeys = (value) => value && typeof value === "object" && !Array.isArray(value)
    ? Object.fromEntries(Object.entries(value).sort(([a], [b]) => a.localeCompare(b)))
    : value;
const canonicalJson = (value) => JSON.stringify(value, (_key, nested) => withSortedKeys(nested));
export const jsonValuesEqual = (a, b) => canonicalJson(a) === canonicalJson(b);
//# sourceMappingURL=equality.js.map